(() => {
  if (window.VidaRoiLazyMedia) {
    window.VidaRoiLazyMedia.initialise(document);
    return;
  }

  const hydrate = (video) => {
    if (!video || video.dataset.vrVideoLoaded === 'true') return;
    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.dataset.vrVideoLoaded = 'true';
    video.load();
    if (video.autoplay && !document.hidden) video.play().catch(() => {});
  };

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          hydrate(video);
          if (video.autoplay && !document.hidden) video.play().catch(() => {});
        } else if (video.autoplay && !video.paused) {
          video.pause();
        }
      });
    }, { threshold: 0.01 })
    : null;

  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-vr-lazy-video]').forEach((video) => {
      if (video.dataset.vrVideoObserved === 'true') return;
      video.dataset.vrVideoObserved = 'true';
      if (observer) observer.observe(video);
      else hydrate(video);
    });
  };

  document.addEventListener('visibilitychange', () => {
    document.querySelectorAll('[data-vr-lazy-video][data-vr-video-loaded="true"]').forEach((video) => {
      if (document.hidden && video.autoplay) video.pause();
      else if (video.autoplay) {
        const rect = video.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < innerHeight) video.play().catch(() => {});
      }
    });
  });
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));

  window.VidaRoiLazyMedia = { initialise, hydrate };
  initialise(document);
})();
